import React from "react";
import Modal from "react-bootstrap/Modal";
import closeIcon from "../../../assets/close.svg";
import "./CropImageModal.scss";
import Cropper from "react-easy-crop";

export default class CropImageModal extends React.Component {
  state = {
    crop: { x: 0, y: 0 },
    zoom: 1,
    aspect: 1,
    croppedAreaPixels: undefined,
    croppedImage: undefined,
  };

  getCroppedImg = async (imageSrc, pixelCrop, rotation = 0) => {
    const createImage = (url) =>
      new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener("load", () => resolve(image));
        image.addEventListener("error", (error) => reject(error));
        image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
        image.src = url;
      });

    const getRadianAngle = (degreeValue) => {
      return (degreeValue * Math.PI) / 180;
    };

    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const maxSize = Math.max(image.width, image.height);
    const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

    // set each dimensions to double largest dimension to allow for a safe area for the
    // image to rotate in without being clipped by canvas context
    canvas.width = safeArea;
    canvas.height = safeArea;

    // translate canvas context to a central location on image to allow rotating around the center.
    ctx.translate(safeArea / 2, safeArea / 2);
    ctx.rotate(getRadianAngle(rotation));
    ctx.translate(-safeArea / 2, -safeArea / 2);

    // draw rotated image and store data.
    ctx.drawImage(
      image,
      safeArea / 2 - image.width * 0.5,
      safeArea / 2 - image.height * 0.5
    );
    const data = ctx.getImageData(0, 0, safeArea, safeArea);

    // set canvas width to final desired crop size - this will clear existing context
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    // paste generated rotate image with correct offsets for x,y crop values.
    ctx.putImageData(
      data,
      Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
      Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
    );

    // As a blob
    // return new Promise(resolve => {
    //   canvas.toBlob(file => {
    //     resolve(URL.createObjectURL(file))
    //   }, 'image/jpeg')
    // })

    return canvas.toDataURL();
  };

  uploadImage = () => {
    this.getCroppedImg(this.props.imageSrc, this.state.croppedAreaPixels)
      .then((res) => {
        this.setState({ croppedImage: res });
        this.props.setProfilePicHandler(res);
        this.props.handleClose();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        crop: { x: 0, y: 0 },
        zoom: 1,
        aspect: 1,
        croppedAreaPixels: undefined,
        croppedImage: undefined,
      });
    }
  }

  render() {
    return (
      <Modal
        className="crop-image-modal"
        size="sm"
        centered
        show={this.props.showModal}
        onHide={this.props.handleClose}
      >
        <div className="crop-image-modal-content">
          <div className="header">
            <h3 className="title">Crop Image</h3>
            <img
              className="close"
              src={closeIcon}
              alt="close"
              onClick={this.props.handleClose}
            />
          </div>

          <div className="body">
            <div className="crop-container">
              <Cropper
                image={this.props.imageSrc}
                crop={this.state.crop}
                zoom={this.state.zoom}
                aspect={this.state.aspect}
                cropShape="round"
                showGrid={false}
                onCropChange={(crop) => this.setState({ crop })}
                onZoomChange={(zoom) => this.setState({ zoom })}
                onCropComplete={(croppedArea, croppedAreaPixels) =>
                  this.setState({ croppedAreaPixels })
                }
              />
            </div>
          </div>

          <div className="footer">
            <button
              className="btn-primary create-button"
              onClick={this.uploadImage}
            >
              Done
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
